var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWowhomeDiscoverProgressStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#10ACE3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.216 17.145-2.548-2.547a.655.655 0 0 0-.462-.19H2.112c-.839 0-1.52.678-1.52 1.518v19.962c0 .84.681 1.52 1.52 1.52h10.776c.84 0 1.52-.68 1.52-1.52v-18.28a.656.656 0 0 0-.192-.463z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.186 31.791H4.13v-4.35a.92.92 0 0 1 .92-.92h.532v3.213h5.603v2.057z",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M8.507 26.52h.52v2.157-2.156zM6.64 26.52h.519v2.157-2.156zM5.052 34.872a.921.921 0 0 1-.921-.92v-1.104 1.103c0 .508.412.921.921.921zM6.81 34.872h-.52v-2.024 2.024zM8.507 34.872h.52v-2.024 2.024zM10.265 34.872c.508 0 .92-.413.92-.92v-1.104 1.103a.922.922 0 0 1-.92.921zM10.265 26.52a.92.92 0 0 1 .92.921v1.236-1.236a.92.92 0 0 0-.92-.92z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#0072AB",
    fill: "#FFF",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AvenirNext-DemiBold, Avenir Next",
    fontSize: 14,
    fontWeight: 500,
    fill: "#0072AB"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.73,
    y: 17
  }, "2"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWowhomeDiscoverProgressStep2);
export default __webpack_public_path__ + "static/media/wowhome-discover-progress-step2.dcb4ccd13a23d1d0d7ef11e4b3568185.svg";
export { ForwardRef as ReactComponent };